/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { findListingEntity } from './helpers/entityReadHelpers';
import { upsertListing } from './helpers/entityAdapter';

export const removeListingKeywords = createAsyncThunk(
  'products/removeListingKeywords',
  async ({
    productId, masterProductId, channelId, keywordIds,
  }, {
    extra: {
      sdk, Logger, utils, showErrorDialog,
    },
  }) => {
    try {
      await sdk.products.removeKeywords([productId], keywordIds);
    } catch (error) {
      const errorMessage = utils.getDataFromResponceError(error, 'msg') || 'Can not remove keywords from product';
      showErrorDialog(errorMessage);
      Logger.error(new Error('Error remove keywords from product'), { error }, [
        'RemoveKeywordFromProductFailed',
        { errorMessage: errorMessage || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(removeListingKeywords.fulfilled, (state, { meta }) => {
    const { masterProductId, channelId, keywordIds } = meta.arg;
    const existingListing = findListingEntity(state, { masterProductId, channelId });
    if (!existingListing) return;

    upsertListing(state, {
      ...existingListing,
      masterProductId,
      keywords: (existingListing.keywords || []).filter((k) => !keywordIds.find((_id) => _id === k._id)),
    });
  });
};
